import type { FaireProductEntity } from "../../entity_types/product";

export const p_n33w5q8vwv: FaireProductEntity = {
  token: "p_n33w5q8vwv",
  type: "product",
  name: "Salted Caramel Rooibos - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/257539470aaf6a3a0e9e02f85385c1208cfe1951345188bd275b6db0b58f3ce4.jpeg",
  galleryImageUrls: [],
  priceDollars: 9.8,
  description: "SUPERFOOD TEA BLEND \n\nCreamy Caramel \n\nGive your barista the night off. This decadent blend captures the creamy, dreamy essence of a Salted Caramel Latte without the caffeine jolt. Nutty rooibos, honeybush, and toasted dandelion root meet the warming, digestive-soothing notes of cinnamon and ginger. It’s the ultimate \"little sweet treat\" for your post-dinner ritual. For the perfect pour, serve with a splash of frothed milk and a drizzle of maple syrup.\n\nCaffeine Free\n\n100% ORGANIC - NUTRITIONIST FORMULATED - SUGAR FREE\n\n\nHow to Enjoy:\n\n * Steep 1 heaping teaspoon of tea in 250ml of 98°C water for 4-6 minutes. Sweeten with maple syrup or honey to taste. \n * Salted Caramel Latte: Steep 1 tbsp of tea in ¾ cup of boiling water. Sweeten to taste. Top with frothed milk \n\nWhen to Steep:\n\n\n * As an afternoon treat without the sugar. \n * As a tea latte instead of your afternoon coffee. \n * When you are under stress. \n\n * As an after-dinner treat. \n * When your digestive system needs some love. \n*Caffeine-free\n\n\n\n",
  tags: [],
  msrpDollars: 15.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:37.723Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
